<mat-dialog-content>
  <ng-container *ngIf="!isImageUrl(data.documentType)">
    <iframe [src]="safeUrl" frameborder="0"> </iframe>
  </ng-container>
  <ng-container *ngIf="isImageUrl(data.documentType)">
    <img [src]="safeUrl" alt="" />
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Chiudi</button>
</mat-dialog-actions>
